<template>
  <div class="boiler-room-wrapper">
    <div class="boiler-room-header">
      <div class="inner">
        <h1 class="title">
          <span class="title-inner"
            ><img src="/assets/sf/icon/boiler.svg" class="title-icon" /><em
              class="title-em"
              >Boiler Room<img
                src="/assets/sf/icon/boiler.svg"
                class="title-icon-sp" /></em
            >Minting & Redeeming</span
          >
        </h1>

        <p class="lead">
          <span class="lead-inner"
            >MINT the Boiler with BUSD. <br />
            Redeem the Boiler to receive the collateralized BUSD and SAUNA.</span
          >
        </p>
      </div>
      <div class="after">
        <div class="detail">
          <span class="header">Boiler Detail</span>
          <div class="box">
            <div class="box-item icon">
              <img src="/assets/sf/icon/boiler.svg" class="box-icon" />
            </div>
            <div class="box-item">
              <div>Price</div>
              <div>$ {{ toCurrency(price) }}</div>
            </div>
            <div class="box-item">
              <div>Total Supply</div>
              <div>{{ toFormattedToken(boilerRoom.totalSupply) }}</div>
            </div>
            <!-- <div class="box-item">
              <div>Max Supply</div>
              <div>{{ toFormattedToken(boilerRoom.maxSupply) }}</div>
            </div> -->
          </div>
        </div>
        <div class="address">
          <span class="header">Contract Address</span>
          <div class="box">
            <span class="address">{{ address }}</span>
            <button class="copy" @click="copy(address)">Copy</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rewardToken from "@/domain/boilerRoom/rewardToken";
import numFormat from "number-format.js";

export default {
  name: "CakelpFarmingHeader",
  computed: {
    address() {
      return rewardToken.contractAddress;
    },
    boilerRoom() {
      return this.$store.state.boilerRoom.data;
    },
    web3() {
      return this.$store.state.web3;
    },
    price() {
      return this.boilerToken.price;
    },
    boilerToken() {
      return this.$store.state.boilerToken;
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat(
        "#,##0.",
        this.web3.instance.utils.fromWei(num, "ether")
      );
    },
    toCurrency(num) {
      return numFormat("#,##0.0000", num);
    },
    copy(value) {
      this.$clipboard(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
.boiler-room-wrapper{
  background-color: var(--color_bg_parts);
  margin-bottom: 56px;
  @include media(sp) {
    margin-bottom: 48px;
  }
}
.boiler-room-header {
  overflow: hidden;
  display: flex;
  margin-bottom: 54px;
  margin: 0 auto;
  width: 1110px;
  .inner {
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    @include media(sp) {
      margin: 0;
    }
  }
  @include media(pc) {
    .inner {
      width: 710px;
      height: 350px;
    }
  }
  @include media(sp) {
    flex-wrap: wrap;
    width: 100%;
    padding: 32px 40px 24px;
  }
}
.title {
  font-weight: 800;
  margin-bottom: 24px;

  @include media(pc) {
    font-size: 3.5rem;
  }
  @include media(sp) {
    font-size: 2.2rem;
  }
}
.title-inner {
  display: inline-block;
  background: $gradation-vertical;
  background-clip: text;
  color: transparent;
  line-height: 1.5;
  font-size: 20px;
}
.title-em {
  margin-right: 0.2em;

  @include media(pc) {
    font-size: 5.5rem;
  }
  @include media(sp) {
    display: block;
    font-size: 3.1rem;
  }
}
.title-icon {
  vertical-align: text-bottom;

  @include media(pc) {
    width: 55px;
    margin: -0.2em 24px 0 0;
  }
  @include media(sp) {
    display: none;
  }
}
.title-icon-sp {
  display: none;
  @include media(sp) {
    display: inline-block;
    width: 36px;
    height: 36px;
    margin: 2px 0 0 6px;
  }
}
.lead-inner {
  display: inline-block;
  background: $gradation-vertical;
  background-clip: text;
  color: transparent;
  font-weight: 400;

  @include media(pc) {
    font-size: 1.7rem;
  }
  @include media(sp) {
    font-size: 1rem;
    margin-bottom: 16px;
  }
}
.after {
  display: table-cell;
  justify-content: center;
  font-size: 1.5rem;
  width: 400px;
  margin: auto;
  @include media(sp) {
    width: 100%;
  }
  .header {
    line-height: 2.4em;
  }
  .box {
    position: relative;
    display: flex;
    background-color: #f7f5fd;
    box-shadow: $box-shadow-inset;
    border-radius: 8px;
    padding: 16px 0;
    margin-bottom: 16px;
    .box-item {
      margin: 0 auto;
      color: #000;
      &.icon {
        width: 43px;
      }
    }
    .box-icon {
      height: 43px;
      width: 43px;
    }
    .address {
      font-weight: normal;
      margin-left: 16px;
      color: #918cad;
      width: calc(100% - 120px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      // @include media(sp) {
      //   width: calc(100% - 120px);
      //   white-space: nowrap;
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      // }
    }
    .copy {
      height: 40px;
      font-size: 1.6rem;
      padding: 0 2rem;
      background: $gradation-vertical;
      color: #fff;
      border-radius: 8px;
      position: absolute;
      right: 16px;
      top: 8px;
    }
  }
}
</style>